import confirmComponent from './confirm.vue'

let $vm

const confirmPlugin = {
	install (vue, pluginOptions = {}) {
		const Confirm = vue.extend(confirmComponent)

		if (!$vm) {
			$vm = new Confirm({
				el: document.createElement('div')
			})
			document.body.appendChild($vm.$el)
		}

		const confirm = {
			show (options) {
				if (typeof options === 'string') {
					Object.assign($vm, pluginOptions, {content: options})
				} else if (typeof options === 'object') {
					Object.assign($vm, pluginOptions, options)
				}
				$vm.show = true
				$vm.$on('CloseEvent', () => {
					$vm.show = false
				})
				$vm.promise = new Promise((resolve, reject) => {
					$vm.$on('OkEvent', () => {
						$vm.show = false
						resolve(true)
					})
					$vm.$on('CancelEvent', () => {
						$vm.show = false
						reject(false)
					})
				})
				return $vm.promise
			}
		}
		vue.prototype.$confirm = confirm.show
	}
}

export default confirmPlugin



// WEBPACK FOOTER //
// ./src/components/common/confirm/index.js